import { render, staticRenderFns } from "./errorsList.vue?vue&type=template&id=39e4b94f"
import script from "./errorsList.vue?vue&type=script&lang=js"
export * from "./errorsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports